import React, { Component } from 'react'
import { ApolloConsumer } from 'react-apollo'
import { gql } from 'apollo-boost'

import { Route } from 'react-router-dom'

import { AUTH_TOKEN_KEY, CURRENT_HOUSE_KEY, MQTT_URI } from '../constants'
import { AuthContext, HouseContext, MqttClientContext } from 'contexts'
import mqtt from 'mqtt'

import IdentificationPage from 'pages/IdentificationPage'

const GET_ME = gql`
  {
    me {
      id,
      houses {
        id, name, description
      }
    }
  }
`

class AppContainer extends Component {

  state = {
    isAuthenticated: false,
    houseId: null,
    mqttClient: null
  }

  loginHandler = async (client) => {
    const { isAuthenticated } = this.state

    try {
      const result = await client.query({
        query: GET_ME
      })

      const currentHouseId = localStorage.getItem(CURRENT_HOUSE_KEY)
      const house = (currentHouseId
        ? result.data.me.houses.find(h => h.id === currentHouseId)
        : null)

      this.setState(() => ({
        isAuthenticated: true,
        houseId: house ? house.id : null,
        mqttClient: mqtt.connect(MQTT_URI)
      }))
    } catch (e) {
      if (this._isMounted && isAuthenticated) {
        this.setState(() => ({isAuthenticated: false}))
      }
    }
  }

  logoutHandler = (client) => {
    client.resetStore().then(() => {
      this.state.mqttClient.end()
      localStorage.removeItem(AUTH_TOKEN_KEY)
      this.setState(() => ({isAuthenticated: false}))
    })
  }

  switchHouseHandler = () => {
    const houseId = localStorage.getItem(CURRENT_HOUSE_KEY)
    this.setState(() => ({
      houseId
    }))
  }

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount = () => {
    this._isMounted = false
  }

  renderUnauthorized = (client) => {
    return (
      <Route path="/" render={(props) => <IdentificationPage loginHandler={this.loginHandler.bind(this, client)} {...props} />} />
    )
  }

  render() {
    const { isAuthenticated, houseId, mqttClient } = this.state

    return (
      <ApolloConsumer>
        {client => {
          if (!isAuthenticated) {
            this.loginHandler(client)
            return this.renderUnauthorized(client)
          }

          return (
            <AuthContext.Provider value={{isAuthenticated, logoutHandler: this.logoutHandler.bind(this, client)}}>
              <MqttClientContext.Provider value={{client: mqttClient}}>
                <HouseContext.Provider value={{houseId, switchHouseHandler: this.switchHouseHandler.bind(this)}}>
                  {this.props.children}
                </HouseContext.Provider>
              </MqttClientContext.Provider>
            </AuthContext.Provider>
          )
        }}
      </ApolloConsumer>
    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js